<template>
  <div class="select-modal" ref="selectModal">
    <hi-dialog
      v-if="!showAddModal"
      class="caption-dialog"
      :title="`Saved ${typeText}`"
      @close="closeDialog"
    >
      <div class="caption-container" v-if="savedList.length !== 0">
        <div
          class="comment-item"
          v-for="item in savedList"
          @click="item.is_default_on = !item.is_default_on"
          :key="item.id"
        >
          <div class="text">{{ item.content }}</div>
          <div class="icon-container">
            <div
              class="select-icon"
              :class="{ select: item.is_default_on }"
            ></div>
          </div>
        </div>
      </div>
      <div class="caption-empty-container" v-if="savedList.length === 0">
        <div>empty</div>
      </div>
      <div class="bottom-container">
        <hi-button type="text" class="add-btn" @click.native="addClick"
          >Add New {{ typeText }}</hi-button
        >
        <hi-button class="save-btn" @click.native="saveClick">Select</hi-button>
      </div>
    </hi-dialog>
    <caption-add
      :type="type"
      @success="addSuccess"
      @close="showAddModal = false"
      v-if="showAddModal"
      :socialNetwork="socialNetwork"
      :publisher-id="publisherId"
    ></caption-add>
  </div>
</template>

<script>
import hiDialog from "../../common/dialog/Index.vue";
import {
  getUserContent,
  mulUpdateUserContent,
} from "../../../service/publisher";
import hiButton from "../../common/button/Index";
import CaptionAdd from "./Add";
import { showErrorMsg } from "../../../utils/errors";

export default {
  name: "SelectCaptionComponent",
  components: { CaptionAdd, hiDialog, hiButton },
  props: {
    type: {
      // caption comment
      required: true,
    },
    publisherId: {
      // 查询的publisher
      required: true,
    },
    socialNetwork: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      savedList: [],
      showAddModal: false, // 是否显示添加页面
    };
  },
  computed: {
    typeText() {
      if (this.socialNetwork === "twitter") {
        if (this.type === "caption") {
          return "Tweets";
        } else {
          return "Reply";
        }
      } else {
        if (this.type === "comment") {
          return "Comment";
        } else {
          return "Caption";
        }
      }
    },
  },
  methods: {
    addSuccess(item) {
      item.is_default_on = true;
      this.savedList.unshift(item);
      this.showAddModal = false;
    },
    closeDialog() {
      this.$parent.showSelectModal = false;
    },
    /**
     * 保存点击事件
     */
    async saveClick() {
      const loading = this.$loading({ target: this.$refs.selectModal });
      try {
        this.savedList.forEach((i) => {
          if (i.is_default_on) {
            i.is_default = true;
          }
        });
        await mulUpdateUserContent({
          publisherId: this.publisherId,
          form: this.savedList,
        });
        // 修改成功
        this.$emit("success");
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    addClick() {
      this.showAddModal = true;
    },
  },
  async created() {
    const loading = this.$loading({ target: this.$refs.selectModal });
    try {
      // 获取当前publisher 类型对应的saved信息
      const list = await getUserContent({
        type: this.type,
        publisherId: this.publisherId,
      });
      this.savedList = list.filter((item) => item.is_saved);
    } catch (e) {
      showErrorMsg(e);
    } finally {
      loading.close();
    }
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/style/theme.less";

.select-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;

  .caption-dialog {
    width: 375px;
    display: flex;
    flex-direction: column;
    height: 730px;
    .caption-empty-container {
      flex: 1;
      align-items: center;
      justify-content: center;
      display: flex;
      color: #8c8c8c;
    }
    .caption-container {
      flex: 1;
      overflow: auto;

      .comment-item {
        min-height: 64px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid @border-color;
        padding: 10px 15px;
        cursor: pointer;

        :hover {
          opacity: 0.7;
        }

        .text {
          font-size: 14px;
          white-space: pre-wrap;
          word-break: break-all;
          flex: 1;
          padding-right: 5px;
        }

        .icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 23px;
          height: 23px;

          .select-icon {
            width: 23px;
            height: 23px;
            background-size: contain;
            cursor: pointer;
            background-image: url("../../../../public/images/bulk/checkbox_checked_able@3x.png");
            &.select {
              background-image: url("../../../../public/images/common/checkbox_checked_select@3x.png");
            }
          }
        }
      }
    }

    .bottom-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 64px;
      padding: 0 20px;
      border-top: 1px solid @border-color;

      .add-btn {
        font-size: 16px;
        padding: 0;
      }
    }
  }
}
</style>
